import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import CircularProgress from '@mui/material/CircularProgress'
import Edit from '@mui/icons-material/Edit'
import Delete from '@mui/icons-material/Delete'
import { FormattedMessage } from 'react-intl'
import { isEmpty } from 'lodash'

const PageSectionList = ({ items, emptyId, renderItem, loading, onItemClick, onItemEdit, onItemDelete }) => {
  if (loading) {
    return <CircularProgress size={24} />
  }

  if (isEmpty(items)) {
    return (
      <Typography variant="body2" color="text.secondary">
        <FormattedMessage id={emptyId} />
      </Typography>
    )
  }

  const handleEdit = (item, event) => {
    event.stopPropagation()
    if (onItemEdit) {
      onItemEdit(item)
    }
  }

  const handleDelete = (item, event) => {
    event.stopPropagation()
    if (onItemDelete) {
      onItemDelete(item)
    }
  }

  const renderSecondaryAction = (item) => {
    if (!onItemEdit && !onItemDelete) return null

    return (
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        {onItemEdit && (
          <IconButton
            edge="end"
            size="small"
            onClick={(e) => handleEdit(item, e)}
          >
            <Edit fontSize="small" />
          </IconButton>
        )}
        {onItemDelete && (
          <IconButton
            edge="end"
            size="small"
            onClick={(e) => handleDelete(item, e)}
          >
            <Delete fontSize="small" />
          </IconButton>
        )}
      </Box>
    )
  }

  return (
    <List disablePadding>
      {items.map((item) => {
        const { primary, secondary } = renderItem(item)

        if (onItemClick) {
          return (
            <ListItem
              key={item.id}
              disablePadding
              secondaryAction={renderSecondaryAction(item)}
            >
              <ListItemButton onClick={() => onItemClick(item)} sx={{ py: 0.5 }}>
                <ListItemText primary={primary} secondary={secondary} />
              </ListItemButton>
            </ListItem>
          )
        }

        return (
          <ListItem
            key={item.id}
            disablePadding
            sx={{ py: 0.5 }}
            secondaryAction={renderSecondaryAction(item)}
          >
            <ListItemText primary={primary} secondary={secondary} />
          </ListItem>
        )
      })}
    </List>
  )
}

export default PageSectionList
